/* --------------------------------
[JSファイルの説明]
・gulpで scripts.json の libs の各ファイルを連結し、 /js/libs.js に書き出している
・gulpで scripts.json の scripts の各ファイルを連結＆圧縮し、 /js/scripts.js に書き出している
・HTMLでは上記の libs.js と scripts.js を読み込んでいる
・もしもgulpの環境が無くて更新が困難な場合は、書き出したJSは無視して scripts.json の各ファイルをHTMLで直接読み込んでも動作は可能
-------------------------------- */

// スクロールバーを除いたウィンドウ幅をCSSのカスタムプロパティに設定
const setVw = function () {
  const vw = document.documentElement.clientWidth;
  document.documentElement.style.setProperty('--vw', `${vw}px`);
}
window.addEventListener('DOMContentLoaded', setVw);
window.addEventListener('resize', setVw);

//aタグ スムーススクロール
$(function () {
  $('a[href^="#"]').click(function () {
    var speed = 500;
    var href = $(this).attr("href");
    var target = $(href == "#" || href == "" ? 'html' : href);
    var position = target.offset().top;
    $("html, body").animate({ scrollTop: position }, speed, "swing");

    $('.p-hd__menu button').removeClass('is-on');
    $('.p-gnav').removeClass('is-on');

    return false;
  });
});

//スライダー
$(function () {
  $('.home-kv__slick').each(function (index, el) {
    const $slider = $(this);

    $slider.slick({
      autoplay: true,
      autoplaySpeed: 3000,
      fade: true,
      speed: 1000,
      pauseOnFocus: false,
      pauseOnHover: false,
      pauseOnDotsHover: false,
      arrows: false,
      dots: false
    });
  });
});

//フェード
$(function () {
  var fade = $('.u-fade, .js-fadeAni');

  fade.each(function (index, el) {
    var t = $(this);

    setTimeout(function () {
      $(window).on('resize scroll', function (event) {
        run();
      });

      run();
    }, 200);

    function run() {
      var winT = $(window).scrollTop();
      var winH = $(window).innerHeight();
      var winB = winT + winH;
      var tT = t.offset().top;
      var tH = t.innerHeight();
      var tB = tT + tH;

      var pointH = tT + 50;
      var pointSc = winB;
      var pointD = 200;

      var h = t.attr('data-fade-h');
      if (h) {
        pointH = tT + tH * h / 100;
      }

      var sc = t.attr('data-fade-sc');
      if (sc) {
        pointSc = winT + winH * sc / 100;
      }

      var d = t.attr('data-fade-delay');
      if (d) {
        pointD = d;
      }

      if (pointH < pointSc) {
        setTimeout(function () {
          t.addClass('is-fade');
          next();
        }, pointD);
      }
    }

    function next() {
      var nextStr = t.attr('data-fade-next-target');
      if (nextStr) {
        var nextArr = nextStr.split(' ');
        if (nextArr) {
          for (var i = 0; i < nextArr.length; i++) {
            var next = nextArr[i];
            var nextTar = $('[data-fade-next-id="' + next + '"]');
            if (nextTar[0]) {
              var nextDelay = t.attr('data-fade-next-delay');
              var delay = 200;
              if (nextDelay) {
                delay = parseInt(nextDelay);
              }

              var nextStep = t.attr('data-fade-next-step');
              var step = 200;
              if (nextDelay) {
                step = delay;
              }
              if (nextStep) {
                step = parseInt(nextStep);
              }

              nextTar.each(function (index, el) {
                var t2 = $(this);
                var step2 = step * index + delay;

                setTimeout(function () {
                  t2.addClass('is-fadeNext');
                  t2.attr('data-test', step2);
                }, step2);
              });
            }
          }
        }
      }
    }
  });
});
  
$(function(){
  $('.p-hd__menu button').each(function (index, element) {
    const $btn = $(this);
    const $nav = $('.p-gnav');

    $btn.on('click', function () {
      $btn.toggleClass('is-on');
      $nav.toggleClass('is-on');
    });
  });
});
  
$(function(){
  $('.l-body.-home .p-hd__logo').each(function (index, element) {
    const $logo = $(this);
    const $kvLogo = $('.home-kv__logo');

    $(window).on('scroll resize', function () {
      run();
    });
    run();
    function run() {
      // console.log($(window).scrollTop(),$kvLogo.offset().top);
      
      if($(window).scrollTop() > $kvLogo.offset().top) {
        $logo.addClass('is-on');
      } else {
        $logo.removeClass('is-on');
      }
    }
  });
});
  
$(function(){
  $('.p-diaModal').each(function (index, element) {
    const $modal = $(this);
    const $hd = $('.p-diaModal__qHd');
    const $bar = $('.p-diaModal__qBar span');
    const $qs = $('.p-diaModal__qs');
    const $q = $('.p-diaModal__q');
    const $btn = $('.p-diaModal__qBtns button');
    const $results = $('.p-diaModal__results');
    const $result = $('.p-diaModal__result');
    const $close = $modal.find('.remodal-close');
    const QLEN = $q.length;
    let now;
    let sel;
    let resultNum;
    let isLock;
    let $now;
    let $next;
    let points;

    init();
    function init() {
      now = 1;
      resultNum = 6;
      isLock = false;
      points = [];

      $q.removeClass('is-sel is-aniStart is-aniEnd');
      $q.filter('[data-num="' + now + '"]').addClass('is-sel is-aniStart');
      $hd.removeAttr('style');
      $bar.removeAttr('style');
      $result.removeClass('is-on is-aniStart')
      $close.removeClass('is-on');
      $btn.removeClass('is-on');
    }
    
    $modal.on('closed', function () {
      init();
    });

    $btn.on('click', function () {
      nextQ($(this));
    });

    function nextQ($t) {
      if(isLock) return false;
      isLock = true;

      $t.addClass('is-on');
      sel = parseInt($t.attr('data-num'));

      points[now] = parseInt($t.attr('data-point'));

      $now = $q.filter('[data-num="' + now + '"]');
      now ++;
      $next = $q.filter('[data-num="' + now + '"]');
      
      $bar.css('width', now * 20 + '%');

      setTimeout(function(){
        $now.addClass('is-aniEnd');

        if(now > QLEN) {
          $hd.stop().fadeOut(300);
          $bar.stop().fadeOut(300);
        }

        setTimeout(function(){
          $now.removeClass('is-sel is-aniStart is-aniEnd');
          $next.addClass('is-sel');

          setTimeout(function(){
            $next.addClass('is-aniStart');

            setTimeout(function(){
              isLock = false;
            }, 300);
          }, 30);

          if(now > QLEN) {
            result();
          }
        }, 300);
      }, 600);
    }

    function arrayShuffle(array) {
      for(let i = (array.length - 1); 0 < i; i--){
        let r = Math.floor(Math.random() * (i + 1));
        let tmp = array[i];
        array[i] = array[r];
        array[r] = tmp;
      }
      return array;
    }

    // 【結果】
    // A…まちの魅力発信アンバサダー
    // B…ワクワク未来のプロデューサー
    // C…まちのアップデート提案者
    // D…強み発揮プレイヤー
    // E…頼れるマルチプレイヤー
    // F…まちウォッチャー

    // 2.【A〜D】個別属性判定
    // 〈条件〉Q1〜Q4のいずれかが「4点以上」の場合、その最高得点タイプを表示。
    // Q1が4点以上→A
    // Q2が4点以上→B
    // Q3が4点以上→C
    // Q4が4点以上→D

    // 1.【E】頼れるマルチプレイヤー判定
    // Q5が「そう思う（少し思う、も含めて）」になった場合は、その他がすべて「どちらでもない（3）」以下の場合

    // 〈タイ判定〉最高得点が複数ある場合（例：Q1とQ2が共に4点など）は、該当するタイプの中からランダムで1つを抽出してください。

    // 3.【F】まちウォッチャー判定
    // 〈条件〉上記1・2のいずれにも該当しない場合（すべての設問が3点以下）。
    function result() {
      let isHit = false;
      let max = 0;
      let cnt, arr;

      arr = [];
      if(!isHit) {
        for (let i = 1; i < points.length - 1; i++) {
          if(points[i] >= 4) {
            if(max < points[i]) max = points[i];
          }
        }
        if(max > 0) {
          for (let i = 1; i < points.length - 1; i++) {
            if(points[i]  == max) {
              arr.push(i);
            }
          }
        }
        if(arr.length > 0) {
          arr = arrayShuffle(arr);
          resultNum = arr[0];
          isHit = true;
        }
      }

      if(!isHit && points[5] >= 4) {
        resultNum = 5;
        isHit = true;
      }

      $result.filter('[data-num="' + resultNum + '"]').addClass('is-on');

      setTimeout(function(){
        $result.filter('[data-num="' + resultNum + '"]').addClass('is-aniStart');
        $close.addClass('is-on');
      }, 30);
    }
  });
});


$(function(){
  $('.js-movieAll').click(function(event) {
    youtubePlayers[0].playVideo();
  });
});

var youtubeTag = document.createElement('script');
youtubeTag.src = "https://www.youtube.com/iframe_api";
var youtubeFirstScriptTag = document.getElementsByTagName('script')[0];
youtubeFirstScriptTag.parentNode.insertBefore(youtubeTag, youtubeFirstScriptTag);
var youtubePlayers = [];

function onYouTubeIframeAPIReady() {
  $('.moviePlayerAuto').each(function(index, el) {
    var t = $(this);
    t.attr('data-player-id', youtubePlayers.length);

    var player = new YT.Player(t[0], {
      height: '360',
      width: '640',
      videoId: t.attr('data-video-id'),
      playerVars: {
      'modestbranding': 1,
      'autohide': 1,
      'controls': 0,
      'showinfo': 0,
      'rel': 0,
      'autoplay': 0,
      'playsinline': 1,
      'loop': 1,
      'playlist': t.attr('data-video-id')
      },
      events: {
        'onReady': onPlayerReady,
        'onStateChange': onPlayerStateChange
      }
    });
    youtubePlayers.push(player);

    function onPlayerStateChange(event) {
      var ytStatus = event.target.getPlayerState();

      // 再生終了したとき
      if (ytStatus == YT.PlayerState.ENDED) {
        event.target.seekTo(0,true);//動画の初めにシーク
        event.target.mute();
        event.target.playVideo();
      }
    }

    // 4. The API will call this function when the video player is ready.
    function onPlayerReady(event) {
      event.target.mute();
      //event.target.playVideo();
    }

    function playVideo() {
      player.mute();
      player.playVideo();
    }

    function stopVideo() {
      player.stopVideo();
    }
  });

  setTimeout(function(){
    $('.js-youtubePlayerModal').each(function(index, el) {
      var t = $(this);
      t.attr('data-player-id', youtubePlayers.length);

      var player = new YT.Player(t[0], {
        height: '360',
        width: '640',
        videoId: t.attr('data-video-id'),
        playerVars: {
        'modestbranding': 1,
        'autohide': 1,
        'controls': 1,
        'showinfo': 0,
        'rel': 0,
        'autoplay': 0,
        'playsinline': 1
        },
        events: {
          'onReady': onPlayerReady,
          'onStateChange': onPlayerStateChange
        }
      });
      youtubePlayers.push(player);

      function onPlayerStateChange(event) {
        /*var ytStatus = event.target.getPlayerState();

        // 再生終了したとき
        if (ytStatus == YT.PlayerState.ENDED) {
          player.mute();
          player.playVideo();
        }*/
      }

      // 4. The API will call this function when the video player is ready.
      function onPlayerReady(event) {
        //event.target.mute();
        //event.target.playVideo();
      }

      function playVideo() {
        player.mute();
        player.playVideo();
      }

      function stopVideo() {
        player.stopVideo();
      }
    });

    $('.remodal').each(function(index, el) {
      var t = $(this);

      t.on('opening', function () {
      });

      t.on('opened', function () {
        var p = youtubePlayers[t.find('.js-youtubePlayerModal').attr('data-player-id')];
        p.playVideo();
      });

      t.on('closing', function (e) {
        var p = youtubePlayers[t.find('.js-youtubePlayerModal').attr('data-player-id')];
        p.stopVideo();
      });

      t.on('closed', function (e) {
        var p = youtubePlayers[t.find('.js-youtubePlayerModal').attr('data-player-id')];
        p.stopVideo();
      });
    });
  }, 100);
}

$(function(){
  $('.onzchishin-report__tabBtns').each(function (index, element) {
    const $btns = $(this);
    const $btn = $btns.find('button');
    const $tabCon = $('.onzchishin-report__tabCon')

    $btn.on('click', function () {
      // $btn.removeClass('is-on');
      // $(this).addClass('is-on');
      run($(this).attr('data-tab-target'));
    });

    if (window.location.hash === '#summary') {
      $btn.filter('[data-tab-target="tab1"]').trigger('click');
    }

    function run(tar = '') {
      const $tar = $('[data-tab-id="' + tar + '"]')

      if($tar[0]) {
        $tabCon.hide();
        $tar.stop().fadeIn(300);
      }
    }
  });
});

$(function(){
  $('.p-gnav__nav').each(function (index, element) {
    const $root = $(this);
    const $parent = $root.find('.-parent');

    $parent.on('click', function () {
      const $t = $(this);
      const $next = $t.next();

      $t.toggleClass('is-on');
      $next.stop().slideToggle(300);

      return false;
    });
  });
})

$(function () {
  $('.onzchishin-db__moreBtn button').on('click', function () {
    const $button = $(this);
    const $content = $('.onzchishin-db__moreCon');

    $button.toggleClass('is-on');
    if ($button.hasClass('is-on')) {
      $content.stop().slideDown(300);
    } else {
      const buttonTop = $button[0].getBoundingClientRect().top;
      $content.stop().fadeOut(300, function () {
        window.scrollBy(0, $button[0].getBoundingClientRect().top - buttonTop);
      });
    }
  });
});

$(function () {
  $('.onzchishin-reportIndex__items > ul').each(function () {
    const $slider = $(this);
    const mediaQuery = window.matchMedia('(max-width: 991px)');

    $slider.on('setPosition', function () {
      const $slides = $slider.find('.slick-slide');
      $slides.css('height', '');

      let maxHeight = 0;
      $slides.each(function () {
        maxHeight = Math.max(maxHeight, $(this).height());
      });
      $slides.height(maxHeight);
    });

    function updateSlider() {
      if (mediaQuery.matches && !$slider.hasClass('slick-initialized')) {
        $slider.slick({
          arrows: false,
          dots: true,
          variableWidth: true,
          infinite: false
        });
      } else if (!mediaQuery.matches && $slider.hasClass('slick-initialized')) {
        $slider.find('.slick-slide').css('height', '');
        $slider.slick('unslick');
      }
    }

    updateSlider();
    mediaQuery.addEventListener('change', updateSlider);
  });
});

